import { Dispatch, SetStateAction, useCallback } from 'react'

const useToggleBoolean = (
  update: Dispatch<SetStateAction<boolean>>,
  setIsEdited?: Dispatch<SetStateAction<boolean>>
) => {
  return useCallback(() => {
    update((prevState) => !prevState)
    setIsEdited && setIsEdited(true)
  }, [update, setIsEdited])
}

export default useToggleBoolean
